import { render, staticRenderFns } from "./StepDisplay.vue?vue&type=template&id=79697090&scoped=true&"
import script from "./StepDisplay.vue?vue&type=script&lang=ts&"
export * from "./StepDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./StepDisplay.vue?vue&type=style&index=0&id=79697090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79697090",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79697090')) {
      api.createRecord('79697090', component.options)
    } else {
      api.reload('79697090', component.options)
    }
    module.hot.accept("./StepDisplay.vue?vue&type=template&id=79697090&scoped=true&", function () {
      api.rerender('79697090', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/wizard/StepDisplay.vue"
export default component.exports